import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const styles = theme => ({
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 3,
  }),
  paperStyle:{

  }
});

function ContainerPaper(props) {
  const { classes, children, style } = props;
  return (
    <div>
      <Paper className={classes.root} elevation={0} style={style}>
        {children}
      </Paper>
    </div>
  );
}

ContainerPaper.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ContainerPaper);



// WEBPACK FOOTER //
// ./src/components/paper/ContainerPaper.js